// extracted by mini-css-extract-plugin
export var brandItem = "BrandsCarousel-module--brandItem--dbeb4";
export var brandsCarouselContainer = "BrandsCarousel-module--brandsCarouselContainer--7199f";
export var brandsCarouselItem = "BrandsCarousel-module--brandsCarouselItem--e1506";
export var cardContainer = "BrandsCarousel-module--cardContainer--5e982";
export var grid = "BrandsCarousel-module--grid--062d6";
export var paddingForNavigationButton = "BrandsCarousel-module--paddingForNavigationButton--bbdd1";
export var pagination = "BrandsCarousel-module--pagination--7be5f";
export var swiper = "BrandsCarousel-module--swiper--41e90";
export var swiperContainer = "BrandsCarousel-module--swiperContainer--1e9c8";